module.exports = __webpack_public_path__ + "img/hr-straight-rail-horizontal-stone-path-background-remnants.1bc0506e.png";